import { Grid } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { convertCurrency } from 'src/common/helpers/currency-helper';
import { TbrData } from 'src/common/interfaces/states/IElectronicJournalRecord';
import { ReactComponent as ReturnItemIcon } from 'src/common/media/return-item-icon.svg';
import { CartItemViewData } from 'src/items-list/business-logic/service/interfaces/cart-response';
import { getTbrReturnItemsTotal } from '../helper/tbr-item-total-price-helper';
import { styles } from './action-window-styles';

const ActionWindowReturnItemHead: React.FC<Props> = (props: Props): JSX.Element => {
  const classes = styles({});
  const { item, tbrData, isKeypadVisible, isTBRActive } = props;
  const { t } = useTranslation();

  return (
    <>
      <Grid
        item
        className={`${classes.item} ${isKeypadVisible ? classes.smallText : ''}`}
        data-testid='action-window-item-name'
      >
        <Grid container>
          <ReturnItemIcon className={classes.icon} />
          <span
            data-testid='return-item-title'
            className={`${classes.superText} ${classes.alignCenter}`}
          >
            {t('SetGetItemToReturnStateCommand')}
          </span>
        </Grid>
      </Grid>
      <Grid container>
        <Grid
          item
          xs={isKeypadVisible ? 8 : 9}
          data-testid='return-item-description'
          className={classes.item}
        >
          {item.description}
        </Grid>
        <Grid
          item
          xs={isKeypadVisible ? 4 : 3}
          className={`${classes.itemPrice} ${classes.textAlignRight}`}
          data-testid='action-window-item-price'
        >
          -
          {convertCurrency(
            (isTBRActive && item ? getTbrReturnItemsTotal(item, tbrData) : item?.amount) ?? 0,
          )}
        </Grid>
      </Grid>
    </>
  );
};

interface Props {
  isKeypadVisible: boolean;
  tbrData: TbrData;
  item: CartItemViewData;
  isTBRActive: boolean;
}

export default ActionWindowReturnItemHead;
